<template>
  <div
    class="cursor-auto"
    v-click-outside="hide"

    @click.stop="openConfig"
  >
    <div class="relative">
      <span>
        <slot></slot>
      </span>

      <transition
        enter-class="mt-2 opacity-0"
        leave-class="mt-0 opacity-100"
        enter-to-class="mt-0 opacity-100"
        leave-to-class="mt-2 opacity-0"
      >
        <div
          v-if="show"
          class="pointer-events-auto duration-150 text-gray-800 space-y-5 border border-gray-200 bg-white w-[35em] shadow-lg absolute left-full top-full z-10 rounded-lg"
        >
          <div class="p-5 pb-0">
            <h3 class="font-bold text-lg">{{ newName }}</h3>
            <div class="mt-5">
              <label for="username" class="block text-sm font-medium text-gray-700">Page name</label>
              <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1" :class="loadingClass">
                <input
                  v-model="$v.newName.$model"

                  type="text"
                  name="username"
                  id="username"
                  ref="name"
                  autocomplete="username"
                  class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                  :class="$v.newName.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                >
              </div>
              <span v-if="$v.newName.$error" class="text-red-600">Page name is required</span>
            </div>
            <div class="mt-5">
              <label for="username" class="block text-sm font-medium text-gray-700">Url</label>
              <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1" :class="loadingClass">
                <span class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm">{{ domainDisplay }}/</span>
                <input
                  v-model="url"
                  :placeholder="urlPlaceholder"

                  type="text"
                  name="username"
                  id="username"
                  autocomplete="username"
                  class="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                >
              </div>
            </div>
          </div>
          <div class="border-t border-gray-200"></div>
          <div class="p-5 py-0 space-y-5">
            <div class="sm:col-span-3">
              <label for="first-name" class="block text-sm font-medium text-gray-700">Meta title</label>
              <div class="mt-1 w-full" :class="loadingClass">
                <input v-model="title" type="text" name="first-name" id="first-name" autocomplete="given-name" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
              </div>
            </div>
            <div class="sm:col-span-6">
              <label for="about" class="block text-sm font-medium text-gray-700">Meta description</label>
              <div class="mt-1 w-full" :class="loadingClass">
                <textarea v-model="description" id="about" name="about" rows="3" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
              </div>
            </div>
            <div class="sm:col-span-6">
              <label for="about" class="block text-sm font-medium text-gray-700">Meta keywords</label>
              <div class="mt-1 w-full" :class="loadingClass">
                <textarea v-model="keywords" id="about" name="about" rows="3" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
              </div>
            </div>
          </div>

          <div class="flex-shrink-0 border-t border-gray-200 px-5 py-4">
            <div class="flex justify-end space-x-3">
              <button
                type="button"
                :class="loadingClass"
                class="space-x-2 inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                @click="save"
              >
                <svg v-if="saving" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators"

import { mapGetters } from "vuex"

export default {
  props: ['name', 'uid'],
  validations: { newName: { required } },
  data() {
    return {
      show: false,
      loading: false,
      saving: false,

      newName: this.name,
      url: "",
      description: "",
      keywords: "",
      title: "",
      config: {},
    }
  },
  methods: {
    async load() {
      this.loading = true

      const { data } = await this.axios.get(`/api/websites/${this.websiteUid}/pages/${this.uid}`)
      const config = data.content ? JSON.parse(data.content) : {}
      this.config = config
      const { url, description, keywords, title } = config.meta || {}

      this.url = url
      this.description = description
      this.keywords = keywords
      this.title = title

      this.loading = false
      this.$refs.name.focus()
    },
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return;

      this.saving = true

      const meta = { url: this.url, description: this.description, keywords: this.keywords, title: this.title }
      const content = { ...this.config, meta }

      await this.axios.put(`/api/websites/${this.websiteUid}/pages/${this.uid}`, {
        name: this.$v.newName.$model,
        type: 'page',
        content: JSON.stringify(content, null, 2)
          .replace(/\"/g, '"'),
      })
      this.$store.dispatch('clearCacheSearch', "websites")
      this.$emit('save')
      this.show = false
      this.saving = false
    },

    hide() {
      this.show = false
    },
    openConfig() {
      requestAnimationFrame(() => this.show = true)
    },
  },
  computed: {
    ...mapGetters({
      domain: "editor/fullDomainLink",
      websiteUid: 'editor/websiteUid',
    }),

    urlPlaceholder() {
      return encodeURIComponent(this.name.replace(/\s/g, '-'))
    },
    loadingClass() {
      return this.loading && 'forced-ske'
    },
    domainDisplay() {
      const split = this.domain.split("https://")
      return `https://...${split[1].substring(split[1].length - 8)}`
    },
  },
  watch: {
    show(val) {
      console.log(val)
      val && this.load()
    },
    newName(newName) {
      this.$emit("set-new-name", newName)
    },
  },
}

</script>
